import { Component, Input } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { CollectionView } from '@grapecity/wijmo'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { DataMap } from '@grapecity/wijmo.grid'

import { BaseComponent, FeatureType, Grid, ModalSize, ProposalBid, ProposalBidDetail } from '../../shared'
import { ActionToolbarButtonsComponent } from '../../shared/reusable-components/action-toolbar-buttons/action-toolbar-buttons.component'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { ProposalBidDetailComponent } from './proposal-bid-detail.component'
import { ProposalBidComponent } from './proposal-bid.component'

@Component({
    selector: 'app-proposal-bids',
    templateUrl: './proposal-bids.component.html',
    standalone: true,
    imports: [
        FormsModule,
        ActionToolbarCount,
        ActionToolbarButtonsComponent,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        WjGridFilterModule,
        WjInputModule,
        AutoSizeDirective,
    ],
})
export class ProposalBidsComponent extends BaseComponent {
    // When rendered as a tab inside the Bid Outlook view, hide this component's own page header
    // so the outer "Bid Outlook" header is not duplicated.
    @Input() embedded = false
    grid: Grid<ProposalBid>
    detailGrid: Grid<ProposalBidDetail>
    jobTypeMap!: DataMap
    countiesMap!: DataMap
    ownersMap!: DataMap
    competitorsMap!: DataMap

    get canEdit() {
        return this.services.authentication.hasFeature([FeatureType.BidAnalyticsEdit])
    }

    constructor() {
        super()
        this.grid = new Grid<ProposalBid>(this.services)
            .setupModalEditing(
                this.services.data.proposalBids,
                'Proposal Bid',
                ProposalBidComponent,
                () => new ProposalBid(),
                this,
                ModalSize.medium,
            )
            .filterBy(item => [item.job])

        this.detailGrid = new Grid<ProposalBidDetail>(this.services)
            .setupModalEditing(
                this.services.data.proposalBidDetails,
                'Proposal Bid Detail',
                ProposalBidDetailComponent,
                () => new ProposalBidDetail(),
                this,
                ModalSize.large,
            )
            .withColumnFilters()
            .wrapColumnHeaders()

        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data
                .load(
                    true,
                    true,
                    this.services.data.proposalBids.queryAll(),
                    this.services.data.proposalBidDetails.queryAll(),
                    this.services.data.jobTypes.queryAll(),
                    this.services.data.counties.queryAll(),
                    this.services.data.get('/api/VpOwner/GetOwners'),
                    this.services.data.get('/api/VpOwner/GetCompetitors'),
                )
                .subscribe({
                    next: result => {
                        this.initialLoadingComplete()
                        this.grid.items = result[0]
                        this.detailGrid.items = result[1]

                        this.jobTypeMap = new DataMap(result[2], 'id', 'fullName')
                        this.countiesMap = new DataMap(result[3], 'id', 'combinedName')
                        this.ownersMap = new DataMap(result[4], 'id', 'name')
                        this.competitorsMap = new DataMap(result[5], 'id', 'name')

                        const view = this.detailGrid.view as CollectionView
                        view._filters.push(x => x.proposalBidId === this.grid.selectedItem?.id)
                    },
                }),
        )
    }

    filterDetailItems() {
        this.detailGrid.flexGridFilter?.clear()
        this.detailGrid.filter = ''
    }
}
